import { render, staticRenderFns } from "./20250403_h5.vue?vue&type=template&id=550bc8e9&scoped=true&"
import script from "./20250403_h5.vue?vue&type=script&lang=js&"
export * from "./20250403_h5.vue?vue&type=script&lang=js&"
import style0 from "./20250403_h5.vue?vue&type=style&index=0&id=550bc8e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550bc8e9",
  null
  
)

export default component.exports